import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FaqsComponent} from 'src/app/pages/area-logada/shared/components/faqs/faqs.component';

import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {FullCalendarModule} from '@fullcalendar/angular';
import {NgbModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {NgxCaptchaModule} from 'ngx-captcha';
import {NgxMaskModule} from 'ngx-mask';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxSpinnerModule} from 'ngx-spinner';
import {WebcamModule} from 'ngx-webcam';
import {TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import {GeiaTableComponent} from 'src/app/components/geia-table/geia-table.component';
import {ValidarCartaoCreditoPipe} from 'src/app/components/helper/pipes/validar-cartao-credito.pipe';
import {AssinaturaDocumentoComponent} from 'src/app/components/shared/components/assinatura-documento/assinatura-documento.component';
import {GeiaButtonComponent} from 'src/app/components/shared/components/geia-button/geia-button.component';
import {ConfirmModalComponent} from 'src/app/components/shared/components/modal/confirm-modal/confirm-modal.component';
import {ModalSimplesComponent} from 'src/app/components/shared/components/modal/modal-simples/modal-simples.component';
import {ModalComponent} from 'src/app/components/shared/components/modal/modal/modal.component';
import {StatusProcessingComponent} from 'src/app/components/shared/components/status-processing/status-processing.component';
import {ValidacaoDocumentoWebcamComponent} from 'src/app/components/shared/components/validacao-documento-webcam/validacao-documento-webcam.component';
import {BreadcrumbComponent} from 'src/app/layouts/breadcrumb/breadcrumb.component';
import {CotacaoInformacoesComponent} from 'src/app/pages/area-logada/cotacao/cotacao-informacoes/cotacao-informacoes.component';
import {CrmFiltroComponent} from 'src/app/pages/area-logada/crm/cadastros/filtro/crm-filtro/crm-filtro.component';
import {DocumentoVisualizarComponent} from 'src/app/pages/area-logada/proposta/documento-visualizar/documento-visualizar.component';
import {CampoDataComponent} from 'src/app/pages/area-logada/shared/components/campo-data/campo-data.component';
import {CaptchaComponent} from 'src/app/pages/area-logada/shared/components/captcha/captcha.component';
import {CardPrincipalComponent} from 'src/app/pages/area-logada/shared/components/card-principal/card-principal.component';
import {FiltroComponent} from 'src/app/pages/area-logada/shared/components/filtro/filtro.component';
import {FormValidationTooltipMessageComponent} from 'src/app/pages/area-logada/shared/components/form-validation-tooltip-message/form-validation-tooltip-message.component';
import {UploadFileComponent} from 'src/app/pages/area-logada/shared/components/upload-file/upload-file.component';
import {CnpjPipe} from 'src/app/pages/area-logada/shared/pipes/cnpj.pipe';
import {CpfPipe} from 'src/app/pages/area-logada/shared/pipes/cpf.pipe';
import {CurrencyBRL} from 'src/app/pages/area-logada/shared/pipes/currencyBRL.pipe';
import {FilterNamePipe} from 'src/app/pages/area-logada/shared/pipes/filterName.pipe';
import {FilterZonePipe} from 'src/app/pages/area-logada/shared/pipes/filterZone.pipe';
import {MesAnoPipe} from 'src/app/pages/area-logada/shared/pipes/mesAno.pipe';
import {
  SliceStringNamePipe,
  SliceTringNameBigTablePipe,
} from 'src/app/pages/area-logada/shared/pipes/slice-string.pipe';
import {ValidacaoFormInputComponent} from 'src/app/pages/area-logada/shared/validators/validacao-form-input/validacao-form-input.component';
import {DocumentosPropostaExternaOdontoPrevComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/documentos-final-proposta-externa/odonto-documento-final/documentos-proposta-externa-OdontoPrev/documentos-proposta-externa-OdontoPrev.component';
import {DocumentosPropostaExternaUnimedOdontoComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/documentos-final-proposta-externa/odonto-documento-final/documentos-proposta-externa-unimedOdonto/documentos-proposta-externa-unimedOdonto.component';
import {DocumentosPropostaExternaUniodontoComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/documentos-final-proposta-externa/odonto-documento-final/documentos-proposta-externa-uniodonto/documentos-proposta-externa-uniodonto.component';
import {PropostaDocumentoFinalUdemoComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/documentos-final-proposta-externa/saude-documento-final/estipulados/proposta-documento-final-udemo/proposta-documento-final-udemo.component';
import {DocumentoFinalMedseniorComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/documentos-final-proposta-externa/saude-documento-final/nao-estipulados/documento-final-medsenior/documento-final-medsenior.component';
import {DocumentoUnimedFespPropostaComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/documentos-final-proposta-externa/saude-documento-final/nao-estipulados/documento-unimed-fesp-proposta/documento-unimed-fesp-proposta.component';
import {PropostaEntidadeDocumentosComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/proposta-entidade-documentos/proposta-entidade-documentos.component';
import {PropostaEntidadeValidacaoDsFotoComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/proposta-entidade-validacao-ds-foto/proposta-entidade-validacao-ds-foto.component';
import {VisualizarLogsPropostaComponent} from 'src/app/pages/modulos/proposta-externa/proposta-associado-entidade/visualizar-logs-proposta/visualizar-logs-proposta.component';
import {AceiteRecusaPortabilidadePropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/aceite-recusa-portabilidade-proposta/aceite-recusa-portabilidade-proposta.component';
import {CartaOrientacaoBeneficiarioComponent} from 'src/app/pages/modulos/proposta-externa/shared/carta-orientacao-beneficiario/carta-orientacao-beneficiario.component';
import {DeclinioPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/declinio-proposta/declinio-proposta.component';
import {DocumentoAditivoComponent} from 'src/app/pages/modulos/proposta-externa/shared/documento-aditivo/documento-aditivo.component';
import {DocumentoCardListComponent} from 'src/app/pages/modulos/proposta-externa/shared/documento-card-list/documento-card-list.component';
import {DocumentoReajusteUdemoComponent} from 'src/app/pages/modulos/proposta-externa/shared/documento-reajuste-udemo/documento-reajuste-udemo.component';
import {EmailsDeclinioPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/emails-declinio-proposta/emails-declinio-proposta.component';
import {FormularioBeneficiarioPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/formulario-beneficiario-proposta/formulario-beneficiario-proposta.component';
import {FormularioDadosBancariosPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/formulario-dados-bancarios-proposta/formulario-dados-bancarios-proposta.component';
import {FormularioInscricaoEntidadeAbjeComponent} from 'src/app/pages/modulos/proposta-externa/shared/formulario-inscricao-entidade/entidades/formulario-inscricao-entidade-abje/formulario-inscricao-entidade-abje.component';
import {FormularioInscricaoEntidadeAdservipComponent} from 'src/app/pages/modulos/proposta-externa/shared/formulario-inscricao-entidade/entidades/formulario-inscricao-entidade-adservip/formulario-inscricao-entidade-adservip.component';
import {HeaderDocumentoFinalPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/header-documento-final-proposta/header-documento-final-proposta.component';
import {ListaDocumentosPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/lista-documentos-proposta/lista-documentos-proposta.component';
import {ManualOrientacaoPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/manual-orientacao-proposta/manual-orientacao-proposta.component';
import {OrientacaoPortabilidadeSumulaPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/orientacao-portabilidade-sumula-proposta/orientacao-portabilidade-sumula-proposta.component';
import {ReducaoCarenciaMedSeniorComponent} from 'src/app/pages/modulos/proposta-externa/shared/reducao-carencia-medSenior/reducao-carencia-medSenior.component';
import {ReducaoCarenciaPropostaComponent} from 'src/app/pages/modulos/proposta-externa/shared/reducao-carencia-proposta/reducao-carencia-proposta.component';
import {EnderecoComponent} from 'src/app/pages/area-logada/shared/components/endereco/endereco.component';
import {AccordionComponent} from 'src/app/pages/area-logada/shared/components/accordion/accordion.component';
@NgModule({
  declarations: [
    ValidacaoFormInputComponent,
    ModalComponent,
    FaqsComponent,
    CnpjPipe,
    CpfPipe,
    FilterZonePipe,
    FilterNamePipe,
    ValidarCartaoCreditoPipe,
    CurrencyBRL,
    MesAnoPipe,
    SliceStringNamePipe,
    GeiaButtonComponent,
    StatusProcessingComponent,
    ConfirmModalComponent,
    SliceTringNameBigTablePipe,
    ModalSimplesComponent,
    CardPrincipalComponent,
    FormValidationTooltipMessageComponent,
    PropostaEntidadeDocumentosComponent,
    DocumentoCardListComponent,
    DocumentoAditivoComponent,
    VisualizarLogsPropostaComponent,
    GeiaTableComponent,
    EmailsDeclinioPropostaComponent,
    AceiteRecusaPortabilidadePropostaComponent,
    ReducaoCarenciaPropostaComponent,
    ManualOrientacaoPropostaComponent,
    FormularioBeneficiarioPropostaComponent,
    FormularioDadosBancariosPropostaComponent,
    OrientacaoPortabilidadeSumulaPropostaComponent,
    ListaDocumentosPropostaComponent,
    DeclinioPropostaComponent,
    DocumentoUnimedFespPropostaComponent,
    DocumentoFinalMedseniorComponent,
    DocumentosPropostaExternaOdontoPrevComponent,
    DocumentosPropostaExternaUniodontoComponent,
    DocumentosPropostaExternaUnimedOdontoComponent,
    PropostaDocumentoFinalUdemoComponent,
    HeaderDocumentoFinalPropostaComponent,
    CotacaoInformacoesComponent,
    FormularioInscricaoEntidadeAdservipComponent,
    DocumentoVisualizarComponent,
    AssinaturaDocumentoComponent,
    FormularioInscricaoEntidadeAbjeComponent,
    CaptchaComponent,
    BreadcrumbComponent,
    FiltroComponent,
    CampoDataComponent,
    PropostaEntidadeValidacaoDsFotoComponent,
    ValidacaoDocumentoWebcamComponent,
    CartaOrientacaoBeneficiarioComponent,
    ReducaoCarenciaMedSeniorComponent,
    DocumentoReajusteUdemoComponent,
    UploadFileComponent,
    CrmFiltroComponent,
    EnderecoComponent,
    AccordionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FullCalendarModule,
    NgSelectModule,
    NgbTooltipModule,

    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    PdfViewerModule,
    NgxPaginationModule,
    BsDatepickerModule,
    NgxMaskModule,
    NgxCaptchaModule,
    TableModule,
    TooltipModule,
    WebcamModule,
    NgbModule,
  ],
  exports: [
    ValidacaoFormInputComponent,
    ModalComponent,
    FaqsComponent,
    CnpjPipe,
    CpfPipe,
    FilterZonePipe,
    FilterNamePipe,
    CurrencyBRL,
    MesAnoPipe,
    SliceStringNamePipe,
    NgxSpinnerModule,
    GeiaButtonComponent,
    StatusProcessingComponent,
    ConfirmModalComponent,
    SliceTringNameBigTablePipe,
    ModalSimplesComponent,
    FullCalendarModule,
    CardPrincipalComponent,
    FormValidationTooltipMessageComponent,

    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    PropostaEntidadeDocumentosComponent,
    DocumentoCardListComponent,
    PdfViewerModule,
    NgxPaginationModule,
    VisualizarLogsPropostaComponent,
    DocumentoAditivoComponent,
    GeiaTableComponent,
    DeclinioPropostaComponent,
    DocumentoUnimedFespPropostaComponent,
    DocumentoFinalMedseniorComponent,
    DocumentosPropostaExternaOdontoPrevComponent,
    DocumentosPropostaExternaUniodontoComponent,
    DocumentosPropostaExternaUnimedOdontoComponent,
    ManualOrientacaoPropostaComponent,
    PropostaDocumentoFinalUdemoComponent,
    HeaderDocumentoFinalPropostaComponent,
    CotacaoInformacoesComponent,
    FormularioInscricaoEntidadeAdservipComponent,
    BsDatepickerModule,
    NgxMaskModule,
    DocumentoVisualizarComponent,
    ReducaoCarenciaPropostaComponent,
    AssinaturaDocumentoComponent,
    FormularioInscricaoEntidadeAbjeComponent,
    OrientacaoPortabilidadeSumulaPropostaComponent,
    NgxCaptchaModule,
    CaptchaComponent,
    FiltroComponent,
    CampoDataComponent,
    BreadcrumbComponent,

    TableModule,
    TooltipModule,
    PropostaEntidadeValidacaoDsFotoComponent,
    ValidacaoDocumentoWebcamComponent,
    CartaOrientacaoBeneficiarioComponent,
    ReducaoCarenciaMedSeniorComponent,
    UploadFileComponent,
    CrmFiltroComponent,
    DocumentoReajusteUdemoComponent,
    EnderecoComponent,
    AccordionComponent,
  ],
})
export class SharedModule {}
